import { InputAdornment, TextField, type SxProps, type Theme } from '@mui/material';
import { ChangeEvent, FocusEvent, HTMLInputTypeAttribute, InputHTMLAttributes, ReactNode, Ref } from 'react';
import { Size, SIZES } from '../../../types/sizes';

type VyTextInputProps = {
  label?: string;
  size?: Extract<Size, typeof SIZES.SMALL | typeof SIZES.MEDIUM>;
  defaultValue?: string;
  placeholder?: string;
  value?: string | number;
  error?: boolean;
  fullWidth?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  endAdornment?: ReactNode;
  startAdornment?: ReactNode;
  inputRef?: Ref<HTMLInputElement>;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  type?: HTMLInputTypeAttribute;
  helperText?: ReactNode;
  sx?: SxProps<Theme>;
  className?: string;
};

export const VyTextInput = ({
  label,
  defaultValue,
  placeholder,
  value,
  onChange,
  size = SIZES.MEDIUM,
  endAdornment,
  startAdornment,
  onBlur,
  error,
  fullWidth,
  inputRef,
  inputProps,
  type,
  helperText,
  sx,
  className,
}: VyTextInputProps) => (
  <TextField
    value={value}
    size={size}
    label={label}
    type={type}
    defaultValue={defaultValue}
    placeholder={placeholder}
    onBlur={onBlur}
    helperText={helperText}
    inputRef={inputRef}
    error={error}
    fullWidth={fullWidth}
    onChange={onChange}
    sx={sx}
    className={className}
    slotProps={{
      input: {
        startAdornment: <InputAdornment position="start">{startAdornment}</InputAdornment>,
        endAdornment: <InputAdornment position="end">{endAdornment}</InputAdornment>,
      },

      htmlInput: inputProps
    }} />
);
